module.exports = " <div class=\"panel panel-default\" _v-79d6ab98=\"\"> <div class=panel-heading _v-79d6ab98=\"\"> <span class=accordion-toggle _v-79d6ab98=\"\"> <h4 class=panel-title _v-79d6ab98=\"\"> <slot name=header _v-79d6ab98=\"\"> {{ header }} </slot> </h4> </span> </div> <div class=panel-collapse v-el:panel=\"\" v-show=isOpen _v-79d6ab98=\"\"> <div class=panel-body _v-79d6ab98=\"\"> <slot _v-79d6ab98=\"\"></slot> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-79d6ab98!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Edid-panel.vue
// module id = 1161
// module chunks = 2